import { CID } from './store.types'

// NOTE: this is duplicated in multiple places
type Option = {
  disabled?: boolean
  label: string
  value: string
}

const createOptions = (items: Record<string, any> | Map<CID, any>, { label }): Option[] => {
  let data = []
  if (items.constructor.name === 'Map') {
    data = Array.from(items.keys())
      .filter((key) => items.get(key)[label])
      .map((key) => ({
        label: items.get(key)[label],
        value: key,
      }))
  } else {
    data = Object.keys(items)
      .filter((key) => items[key][label])
      .map((key) => ({
        label: items[key][label],
        value: key,
      }))
  }
  return data.sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()))
}

const markDisabledOptions = (options: Option[], selectedItems) => {
  return options.map((option) => {
    return {
      ...option,
      disabled: selectedItems.includes(option.value),
    }
  })
}

const scrollToError = (v$, field_keys) => {
  for (const key of field_keys) {
    if (v$.value[key]?.$errors[0]) {
      // Scroll to the invalid field
      const fieldElement = document.querySelector(`[name="${key}"]`)
      if (fieldElement) {
        fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      break // Stop after finding the first invalid field
    }
  }
}

/**
 * Recursively converts a nested object into FormData with Rails bracket notation.
 * e.g. { spv: { name: 'foo', admin_ids: [1, 2] } }
 * becomes: spv[name]=foo, spv[admin_ids][]=1, spv[admin_ids][]=2
 */
function toFormData(obj: Record<string, any>): FormData {
  const formData = new FormData()
  appendToFormData(formData, '', obj)
  return formData
}

function appendToFormData(formData: FormData, prefix: string, value: any): void {
  if (value === null || value === undefined) return

  if (value instanceof File) {
    formData.append(prefix, value)
  } else if (Array.isArray(value)) {
    value.forEach((item) => {
      appendToFormData(formData, `${prefix}[]`, item)
    })
  } else if (typeof value === 'object') {
    for (const key in value) {
      const nestedKey = prefix ? `${prefix}[${key}]` : key
      appendToFormData(formData, nestedKey, value[key])
    }
  } else {
    formData.append(prefix, String(value))
  }
}

export { Option, createOptions, markDisabledOptions, scrollToError, toFormData }
